import { HttpHeaders } from "@angular/common/http";

export function prepareHeaders(args = null): HttpHeaders {
  let headers = new HttpHeaders();

  headers = headers.append(
    "Authorization",
    "Bearer " + JSON.parse(localStorage.getItem("auth")).apiToken
  );
  // @TODO: add args as well
  return headers;
}

export function prepareAuthHeaders(args = null): HttpHeaders {
  let headers = prepareHeaders(args);
  return headers;
}



// WEBPACK FOOTER //
// ./src/providers/headers.ts